// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"breadcrumbs--2a759"};